module.exports = __webpack_public_path__ + "img/annotation-question.f46ccfa7.svg";